import React from 'react';
import { observe } from 'mobx';
import { observer, Observer } from 'mobx-react';
import { AutoSizer } from 'react-virtualized';
import AnimatedList from './AnimatedList';
import { appStore } from '../store';
import { navigateTo } from '../navutils';


const NativeSidebarNative = observer(({ data, addRefCb, style, language }) => {
  const clickCB = (event) => {
    navigateTo('?_' + data.native.hash);
    event.preventDefault();
  };

  return (
    <div
      className={((data.active) ? 'active ' : '') + 'native entry'}
      id={'li_' + data.native.hash}
      ref={(el) => addRefCb(data.native.hash, el)}
      style={style}
    >
      <a href={'?_' + data.native.hash} onClick={clickCB}>
        {language.renderName(data.native)}
        <span className={data.native.params.length === 0 ? 'hidden' : ''}>
          ({language.formatRefParams(data.native)})
        </span>
      </a>
    </div>
  )
});

const NativeSidebarNamespace = observer(({ data, style }) => {
  const clickCB = (event, hash) => {
    navigateTo('?n_' + data.native.name);
    event.preventDefault();
  };

  return (
    <div className="namespace entry" style={style}>
      <a href={'?n_' + data.native.name} onClick={clickCB}>
        <span>Namespace:&nbsp;</span>{data.native.name}
      </a>
    </div>
  );
});


@observer
export class NativesList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderRow = this.renderRow.bind(this);
    this.getRowHeight = this.getRowHeight.bind(this);

    this.aniListRef = React.createRef();

    observe(appStore.viewNativeList, () => {
      this.aniListRef.current.listRef.current.recomputeRowHeights();
    });
  }

  renderRow({ key, index, style }) {
    const { language, addRefCb, followLink } = this.props;

    const entry = appStore.viewNativeList.natives[index];

    if (entry.native.type === 'namespace') {
      return (<NativeSidebarNamespace key={key} data={entry} style={style} followLink={followLink} />);
    } else {
      return (<NativeSidebarNative
        key={key}
        data={entry}
        language={language}
        addRefCb={addRefCb}
        style={style}
      />);
    }
  }

  getRowHeight({ index }) {
    return appStore.viewNativeList.natives[index].native.type === 'native'
      ? 32
      : 32;
  }

  render() {
    return (
      <section>
        <AutoSizer>
          {({ height, width }) => (
            <Observer>
              {() => (<AnimatedList
                width={width}
                height={height}
                ref={this.aniListRef}
                rowCount={appStore.viewNativeList.natives.length}
                rowHeight={this.getRowHeight}
                rowRenderer={(options) => (<Observer key={options.key} style={options.style /* this is to shut up a warning message */}>
                  {() => this.renderRow(options)}
                </Observer>)}
                scrollToIndex={appStore.selection.curIndex}
                duration={(appStore.selection.initialScroll) ? 0 : 150}
                easing={(n) => n * n}
                onAnimationComplete={() => appStore.selection.initialScroll = false}
              />)}
            </Observer>
          )}
        </AutoSizer>
      </section>
    );
  }
};
